import { render } from "./Share.vue?vue&type=template&id=3e214460&scoped=true&ts=true"
import script from "./Share.vue?vue&type=script&lang=ts"
export * from "./Share.vue?vue&type=script&lang=ts"

import "./Share.vue?vue&type=style&index=0&id=3e214460&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e214460"]])

export default __exports__